import React from "react";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/helpers";

function DesktopArticleCard({ marketPulse = []}) {
  const navigate = useNavigate();

  // Default data
  const defaultData = {
    id: 1,
    article_title: "Market Analysis: Tech Stocks Show Strong Growth Potential",
    created_at: new Date().toISOString(),
    cover_image_url: "https://via.placeholder.com/300x200",
  };

  // Use provided data or fall back to defaults
  const articleData = {
    ...defaultData,
    ...marketPulse,
  };

  return (
    <div
      onClick={() =>
        navigate(
          `/gallyonomics/details/${slugify(articleData.article_title)}/${
            articleData.id
          }`
        )
      }
      className="w-[99%] mx-auto bg-white p-4 overflow-hidden font-afacad h-24 flex flex-col justify-between cursor-pointer hover:shadow-sm transition-shadow duration-200"
    >
      <div>
        <h4 className="font-medium truncate overflow-hidden text-ellipsis h-6">
          {articleData.article_title}
        </h4>
        <div className="text-xs text-gray-500">
          {new Date(articleData.created_at).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>
      </div>
    </div>
  );
}

export default DesktopArticleCard;
